// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"116c94c0","419":"41e88d24","563":"9a218184","787":"2f31f199","942":"628015b1"}[chunkId] + ".chunk.js";
};